
import { defineComponent } from 'vue';
import Header from './Components/header.vue';
import NavBar from './Components/navBar.vue';
import FooterComp from './Components/footerComp.vue';

export default defineComponent({
    components: { Header, NavBar, FooterComp }
})

